import React from 'react'

import { formatChatTimestamp } from '~/core/utils/dates'
import { Bubble, BubbleContainer, ChatAvatar, Content, Time } from './styled'
import { Body01, LabelBold01 } from '~/components/common/typography'

const ChatEntry = ({ entry, hideInfo, hideTimestamp }) => {
  const { content, name, timestamp } = entry
  const formattedTimestamp = formatChatTimestamp(timestamp)

  return (
    <Content>
      <ChatAvatar
        hidden={hideInfo}
        name={name}
        size='xsmall'
        useDynamicColor
      />
      <BubbleContainer>
        <Bubble>
          {!hideInfo && <LabelBold01>{name}</LabelBold01>}
          <Body01>{content}</Body01>
        </Bubble>
        {!hideTimestamp && <Time data-id={`timestamp-${formattedTimestamp}`}>{formattedTimestamp}</Time>}
      </BubbleContainer>
    </Content>
  )
}

export default ChatEntry
